// Import specific icons
import {
  faUserSecret,
  faFishFins,
  faWheatAwn,
  faEgg,
  faGlassWaterDroplet,
  faChevronLeft,
  faChevronRight,
  faEdit,
  faPlus,
  faCopy,
  faUtensils,
  faCalendarDay,
  faTimes,
  faExclamationTriangle,
  faInfoCircle,
  faLightbulb
} from '@fortawesome/free-solid-svg-icons'

import {
  faTrash,
  faTrashCanXmark,
  faSpinnerThird,
  faWandMagic,
  faWandMagicSparkles,
  faSalad
} from '@fortawesome/pro-duotone-svg-icons'

// Export as object values (array) for library.add()
export default [
  faUserSecret,
  faFishFins,
  faWheatAwn,
  faEgg,
  faGlassWaterDroplet,
  faChevronLeft,
  faChevronRight,
  faEdit,
  faPlus,
  faCopy,
  faUtensils,
  faCalendarDay,
  faTimes,
  faExclamationTriangle,
  faInfoCircle,
  faLightbulb,
  faTrash,
  faTrashCanXmark,
  faSpinnerThird,
  faWandMagic,
  faWandMagicSparkles,
  faSalad
]
